module.exports = __webpack_public_path__ + "static/img/weixin.84c34c0b.png";